@import '~style-sheet-helpers/core.less';
@import '../../../../../../constants/spacing.module.less';

.step-wrapper {
  text-align: center;
}

.result-error-btn {
  margin-top: @space-16;
}

.loading-info {
  display: flex;
  height: 40px;
  width: 100%;
}

.loading-indicator {
  width: 100px;
  height: 100px;
  margin: auto;
}

.import-in-progress {
  margin-top: @space-8;
  font-weight: 500;
  font-size: 16px;
}

.close-info {
  margin: @space-8 @space-0 @space-12 @space-36;
  text-align: left;
  color: var(--grey-600);
}

.result {
  margin-top: @space-24;
}

.import-result {
  text-align: left;
  margin: @space-4 @space-0;
}

.close-btn {
  margin-left: auto;

  :global(.button-primary) {
    font-weight: 600;
  }
}

@error-border-color: 1px solid var(--grey-300);
@error-icon-color: var(--gold-500);

.error-header-summary {
  background-color: var(--grey-200);
  padding: @space-8 @space-12;
  font-weight: 500;
  color: var(--grey-800);
  border: @error-border-color;
  text-align: left;
  line-height: 1;
}

.error-message {
  padding: @space-12 @space-24;
  color: var(--grey-850);
  border-bottom: @error-border-color;
  border-left: @error-border-color;
  border-right: @error-border-color;
  display: flex;
}

.error-header {
  background-color: var(--gold-200);
  padding: @space-8 @space-12;
  font-size: 12px;
  color: var(--grey-900);
  border: 1px solid var(--gold-300);
  text-align: left;
  margin-bottom: @space-12;
  line-height: 16px;

  > svg {
    color: @error-icon-color;
    width: 14px;
    margin-right: @space-8;
  }

  .error-header-message {
    font-size: 12px;
    display: inline;
  }
}

.active-import {
  padding: @space-16;
  border-radius: 4px;
  border: 1px solid var(--gray-DFE4E8);
  margin: @space-24 @space-0;
}

.active-import-title {
  text-align: left;
}

.active-import-progress {
  text-align: right;
  margin-top: @space-8;
  color: var(--grey-900);
}

.import-success {
  margin-top: @space-48;
  margin-bottom: @space-48;

  .icon-success {
    color: var(--green-700);
    width: 72px;
    height: 72px;
  }
}

.import-success-message {
  margin-top: @space-24;
  margin-bottom: @space-12;
}

.import-success-details {
  border-radius: 4px;
}

.progress-bar {
  height: 8px;
  border-radius: 24px;
  margin-top: @space-4;
}
